import { Button, Card, Grid } from '@material-ui/core'
import { useContext, useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { getPartDetails } from '../../../actions/partActions'
import { listUserPrograms } from '../../../actions/programActions'
import defaultPartImg from '../../../assets/img/default-part.png'
import { MACHINE_UPDATE_RESET } from '../../../constants/machineConstants'
import { PART_UPDATE_RESET } from '../../../constants/partConstants'
import {
  PROGRAM_CREATE_RESET,
  PROGRAM_UPDATE_RESET,
} from '../../../constants/programConstants'
import {
  PROJECT_CURRENT_STEP,
  PROJECT_UPDATE_RESET,
} from '../../../constants/projectConstants'
import { Context } from '../../../providers/ProjectContextProvider'
import FormContainer from '../../Form/FormContainer'
import NumberInput from '../../Form/NumberInput'
import SelectInput from '../../Form/SelectInput'
import TextAreaInput from '../../Form/TextAreaInput'
import Loader from '../../Loader/Loader'
import AddEditMachine from '../../Machine/AddEditMachine'
import Message from '../../Message/Message'
import ModalPopUp from '../../ModalPopUp/ModalPopUp'
import AddEditPart from '../../Part/AddEditPart'
import ToastMessage from '../../ToastMessage/ToastMessage'
import SelectMachine from '../SelectMachine/SelectMachine'
import ProgramTable from './ProgramTable'

const ProgramDetailsContainer = styled.div`
  .image-bg {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .has-thumb {
    padding: 0;
    background-size: cover;

    .image-bg {
      height: 75px;
    }
  }

  .no-thumb {
    padding: 10px;

    .image-bg {
      background-size: contain;
      height: 55px;
    }
  }

  .MuiTableCell-root {
    display: table-cell;
    padding: 8px 16px;
  }

  .MuiFormControlLabel-root {
    margin-left: 0;
    margin-bottom: 0;
  }

  .MuiTableContainer-root.scrollable {
    max-height: 413px;
  }
`

interface ProgramDetailsProps {
  setShowAddProgram: (show: boolean) => void
  selectedPartId: string
  selectedPrograms: Program[]
  setSelectedPrograms: React.Dispatch<React.SetStateAction<Program[]>>
  setProgramToEdit: React.Dispatch<React.SetStateAction<Program | undefined>>
  qty: number | undefined
  setQty: (qty: number | undefined) => void
  hasProgram: string | boolean | undefined
  keepProgram: string | boolean | undefined
  bindHasProgram: any
  bindKeepProgram: any
  bindNotes: any
  selectedMachineId: string
  setSelectedMachineId: (machineId: string) => void
  resetRequestValues: () => void
}

const ProgramDetails = ({
  setShowAddProgram,
  selectedPartId,
  selectedPrograms,
  setSelectedPrograms,
  setProgramToEdit,
  qty,
  setQty,
  hasProgram,
  keepProgram,
  bindHasProgram,
  bindKeepProgram,
  bindNotes,
  selectedMachineId,
  setSelectedMachineId,
  resetRequestValues,
}: ProgramDetailsProps) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { currentStep } = useSelector(
    (state: RootStateOrAny) => state.projectStep
  )

  const [programsSet, setProgramsSet] = useState(false)
  const [partSet, setPartSet] = useState(false)
  const [partName, setPartName] = useState('')
  const [thumbnailImage, setThumbnailImage] = useState('')
  const [nextIsReady, setNextIsReady] = useState(false)
  const [createToast, setCreateToast] = useState(false)
  const [deleteToast, setDeleteToast] = useState(false)
  const [showPartQuantity, setShowPartQuantity] = useState(currentStep === '3b')
  const [qtyError, setQtyError] = useState('')
  const [updatedProgramName, setUpdatedProgramName] = useState('')
  const [updateProgramToast, setUpdateProgramToast] = useState(false)
  const [showAddMachine, setShowAddMachine] = useState(false)
  const [showSelectMachine, setShowSelectMachine] = useState(false)
  const [showProgrammingModal, setShowProgrammingModal] = useState(false)
  const [machineToEdit, setMachineToEdit] = useState<Machine | undefined>(
    undefined
  )
  const [showAddPart, setShowAddPart] = useState(false)
  const [partToEdit, setPartToEdit] = useState<Part | undefined>(undefined)
  const [stayOnPage, setStayOnPage] = useState(false)

  const { success: programCreateSuccess, program: createdProgram } =
    useSelector((state: RootStateOrAny) => state.programCreate)
  const { success: programDeleteSuccess } = useSelector(
    (state: RootStateOrAny) => state.programDelete
  )
  const { success: programUpdateSuccess, program: updatedProgram } =
    useSelector((state: RootStateOrAny) => state.programUpdate)
  const { success: partUpdateSuccess } = useSelector(
    (state: RootStateOrAny) => state.partUpdate
  )
  const { success: machineUpdateSuccess } = useSelector(
    (state: RootStateOrAny) => state.machineUpdate
  )
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = useSelector((state: RootStateOrAny) => state.projectUpdate)
  const { part } = useSelector((state: RootStateOrAny) => state.partDetails)
  const { userInfo } = useSelector(
    (state: { userLogin: UserLogin }) => state.userLogin
  )
  const { project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )
  const { setShowNotifyUser } = useContext(Context)

  useEffect(() => {
    if (stayOnPage) {
      setStayOnPage(false)
    } else {
      if (successUpdate) {
        resetRequestValues()
        dispatch({ type: PROJECT_UPDATE_RESET })
        dispatch({
          type: PROJECT_CURRENT_STEP,
          payload: 5,
        })
      }
    }

    if (partUpdateSuccess) {
      if (keepProgram === 'No') {
        setShowPartQuantity(true)
      } else {
        setShowSelectMachine(true)
        setShowProgrammingModal(true)
      }

      dispatch({ type: PART_UPDATE_RESET })
    }

    if (machineUpdateSuccess) {
      setShowSelectMachine(true)
      setShowProgrammingModal(true)
      dispatch({ type: MACHINE_UPDATE_RESET })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    successUpdate,
    dispatch,
    resetRequestValues,
    partUpdateSuccess,
    machineUpdateSuccess,
    keepProgram,
  ])

  useEffect(() => {
    if (part) {
      setPartName(part.name)
      setPartToEdit(part)

      if (part.thumbnail) {
        const getThumbnail = async () => {
          try {
            setThumbnailImage(
              `${process.env.REACT_APP_API}/api/thumbnail/${part.thumbnail.id}`
            )
          } catch (error) {
            console.error(error)
          }
        }

        getThumbnail()
      }
    }

    if (!partSet) {
      setPartSet(true)
      dispatch(getPartDetails(selectedPartId))
    }

    if (!programsSet) {
      setProgramsSet(true)
      dispatch(listUserPrograms(project.user))
    }

    if (programCreateSuccess) {
      window.scrollTo(0, 0)

      setSelectedPrograms([...selectedPrograms, createdProgram])
      setCreateToast(true)
      dispatch({ type: PROGRAM_CREATE_RESET })
    }

    if (programUpdateSuccess) {
      setProgramToEdit(undefined)
      setUpdatedProgramName(updatedProgram.name)
      setUpdateProgramToast(true)
      dispatch({ type: PROGRAM_UPDATE_RESET })
      window.scrollTo(0, 0)
    }

    if (programDeleteSuccess) {
      setDeleteToast(true)
      dispatch({ type: PROGRAM_CREATE_RESET })
    }

    if (
      (hasProgram === true && selectedPrograms.length > 0) ||
      (hasProgram === false && keepProgram !== '')
    ) {
      setNextIsReady(true)
    } else {
      setNextIsReady(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    programCreateSuccess,
    dispatch,
    programsSet,
    programDeleteSuccess,
    hasProgram,
    keepProgram,
    selectedPrograms,
    selectedPartId,
    partSet,
    part,
    updatedProgram,
    programUpdateSuccess,
    setProgramToEdit,
    createdProgram,
    setSelectedPrograms,
  ])

  const toggleSelectedProgram = (program: Program) => {
    const alreadyInList = selectedPrograms.filter(
      (x) => x.name === program.name
    ).length

    if (!alreadyInList) {
      setSelectedPrograms([...selectedPrograms, program])
    } else {
      const newState = selectedPrograms.filter((x) => x.name !== program.name)
      setSelectedPrograms(newState)
    }
  }

  const handleQtyNext = () => {
    if (!qty) {
      setQtyError('Please enter a quantity')
    } else {
      dispatch({
        type: PROJECT_CURRENT_STEP,
        payload: 4,
      })
    }
  }

  const handleDesignateProgramNext = () => {
    if (!hasProgram) {
      if (keepProgram === 'No') {
        if (part.partProgramFiles.length) {
          setShowPartQuantity(true)
        } else {
          setShowAddPart(true)
          setShowProgrammingModal(true)
        }
      } else {
        setShowAddPart(part.partProgramFiles.length ? false : true)
        setShowSelectMachine(part.partProgramFiles.length ? true : false)
        setShowProgrammingModal(true)
      }
    }

    if (hasProgram) {
      setShowPartQuantity(true)
    }
  }

  const handleBackClick = () => {
    setShowPartQuantity(false)
    dispatch({
      type: PROJECT_CURRENT_STEP,
      payload: 3,
    })
  }

  const handlePartEditCancelClick = () => {
    setShowAddPart(false)
    setShowProgrammingModal(false)
  }

  const handleModalClose = () => {
    setShowProgrammingModal(false)
    setShowAddPart(false)
    setShowAddMachine(false)
  }

  const handleProgramDetailsNextClick = () => {
    setShowPartQuantity(true)
    setShowProgrammingModal(false)
    setShowSelectMachine(false)
  }

  const handleSaveAndExit = () => {
    if (userInfo.isAdmin) {
      setStayOnPage(true)
      setShowNotifyUser(true)
    } else {
      history.push('/myquality/dashboard')
    }
  }

  return (
    <>
      {!showPartQuantity ? (
        <ProgramDetailsContainer>
          <FormContainer>
            <h4 className="m-b-30">
              Designate program{' '}
              {userInfo.isAdmin &&
                project.userName &&
                `for ${project.userName}`}
            </h4>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SelectInput
                  label="Do you have a program for this quote request?"
                  name="hasProgram"
                  options={[
                    { value: true, label: 'Yes, I have a program' },
                    { value: false, label: 'No, I do not have a program' },
                  ]}
                  bindValue={bindHasProgram}
                />
              </Grid>

              {hasProgram === true && (
                <Grid item xs={12}>
                  <ProgramTable
                    setProgramToEdit={setProgramToEdit}
                    setShowAddProgram={setShowAddProgram}
                    toggleSelectedProgram={toggleSelectedProgram}
                    selectedPrograms={selectedPrograms}
                    setSelectedPrograms={setSelectedPrograms}
                  />
                </Grid>
              )}

              {hasProgram === false && (
                <Grid item xs={12}>
                  <h5 className="primary m-t-16">
                    No problem - our Application Engineers can create one for
                    you.
                  </h5>
                  <SelectInput
                    label="Do you need to keep the program created for inspection?"
                    name="hasProgram"
                    options={[
                      {
                        value: 'Yes',
                        label:
                          'Yes, I would like to keep my program and add programming to this request',
                      },
                      {
                        value: 'Not sure',
                        label:
                          'Not sure, I would like to talk to someone about this service',
                      },
                      {
                        value: 'No',
                        label: 'No, I do not need to keep the program',
                      },
                    ]}
                    bindValue={bindKeepProgram}
                  />
                </Grid>
              )}

              {hasProgram === false && (
                <Grid item xs={12}>
                  <TextAreaInput
                    name="notes"
                    label="Notes"
                    bindValue={bindNotes}
                    rows={4}
                    className="m-b-16"
                  />
                </Grid>
              )}
            </Grid>

            <div className="actions m-t-40 flex space-between">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveAndExit}
              >
                Save and exit
              </Button>

              <div>
                <Button
                  variant="outlined"
                  color="primary"
                  className="m-r-24"
                  onClick={() =>
                    dispatch({
                      type: PROJECT_CURRENT_STEP,
                      payload: 2,
                    })
                  }
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!nextIsReady}
                  onClick={handleDesignateProgramNext}
                  className={loadingUpdate ? 'loading' : ''}
                >
                  {loadingUpdate ? <Loader /> : 'Next'}
                </Button>
              </div>
            </div>

            {errorUpdate && <Message variant="error">{errorUpdate}</Message>}
          </FormContainer>
        </ProgramDetailsContainer>
      ) : (
        <ProgramDetailsContainer>
          <FormContainer>
            <h4 className="m-b-30">Part quantity</h4>

            <h5 className="m-b-16">How many parts need to be inspected?</h5>

            <Card style={{ padding: 16 }}>
              <Grid container spacing={2}>
                <Grid item xs={7}>
                  <div className="fs16 primary text bold m-b-32">Part name</div>

                  <Grid container spacing={2}>
                    <Grid item xs={2}>
                      <div
                        className={`light-blue-bg ${
                          thumbnailImage ? 'has-thumb' : 'no-thumb'
                        }`}
                      >
                        <div
                          className="image-bg"
                          style={{
                            backgroundImage: `url(${
                              thumbnailImage ? thumbnailImage : defaultPartImg
                            })`,
                          }}
                        ></div>
                      </div>
                    </Grid>
                    <Grid item xs={10}>
                      <div className="fs14 bold">{partName}</div>

                      {selectedPrograms.length > 0 &&
                        selectedPrograms.map((program, index) => (
                          <div key={index} className="gray-text fs10">
                            {program.name}
                          </div>
                        ))}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={3}>
                  <div className="fs16 primary text bold m-b-32">
                    Qty for inspection
                  </div>
                  <label>Quantity</label>
                  <NumberInput
                    value={qty}
                    setValue={setQty}
                    error={qtyError}
                    label={null}
                  />
                </Grid>

                <Grid item xs={2}></Grid>
              </Grid>
            </Card>

            <div className="actions m-t-40 flex space-between">
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveAndExit}
              >
                Save and exit
              </Button>

              <div>
                <Button
                  variant="outlined"
                  color="primary"
                  className="m-r-24"
                  onClick={handleBackClick}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleQtyNext}
                >
                  Next
                </Button>
              </div>
            </div>
          </FormContainer>
        </ProgramDetailsContainer>
      )}

      <ModalPopUp
        title={showAddPart ? 'Complete part details' : 'Select machine'}
        setShowModal={handleModalClose}
        showModal={showProgrammingModal}
        disableBackdropClick={true}
        variant="full"
      >
        {showAddPart && (
          <AddEditPart
            type={'programming'}
            setShowAddPart={handlePartEditCancelClick}
            partToEdit={partToEdit}
            setPartToEdit={setPartToEdit}
            partTitleOverride={'Please complete part details to continue'}
          />
        )}

        {!showAddPart && showSelectMachine && !showAddMachine && (
          <SelectMachine
            setShowAddMachine={setShowAddMachine}
            selectedMachineId={selectedMachineId}
            setSelectedMachineId={setSelectedMachineId}
            setMachineToEdit={setMachineToEdit}
            isProgramDetailsModal={true}
            setShowProgrammingModal={setShowProgrammingModal}
            handleProgramDetailsNextClick={handleProgramDetailsNextClick}
          />
        )}
        {!showAddPart && showAddMachine && (
          <AddEditMachine
            setShowAddMachine={setShowAddMachine}
            machineToEdit={machineToEdit}
            setMachineToEdit={setMachineToEdit}
          />
        )}
      </ModalPopUp>

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Program added</p>
            <p className="fs14 m-b-0">
              You successfully created a part program
            </p>
          </>
        }
        open={createToast}
        setOpen={setCreateToast}
      />

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Program deleted</p>
            <p className="fs14 m-b-0">Part program successfully deleted</p>
          </>
        }
        open={deleteToast}
        setOpen={setDeleteToast}
      />

      <ToastMessage
        message={
          <>
            <p className="fs16 fw600">Program updated</p>
            <p className="fs14 m-b-0">
              You successfully updated {updatedProgramName}.
            </p>
          </>
        }
        open={updateProgramToast}
        setOpen={setUpdateProgramToast}
      />
    </>
  )
}

export default ProgramDetails
